/**
 * Created by Mark on 18/04/2017.
 */


import React from 'react';
import InternationalizationStore from '../../../store/internationalization-store.js'
import { FormattedMessage } from 'react-intl';
import {Pagination , Table , Checkbox , Nav , NavItem , Row , Col , FormGroup , FormControl , ControlLabel} from 'react-bootstrap';
import DataInput from '../../inputs/date.input.js'
import Search  from "../../tables/table.search.component.js";
import ClassesService from "../../../services/classes-service.js";
import ClassesStore from "../../../store/classes-store.js";
import Toggle from '../../inputs/input.toggle.component.js';
import Select from  'react-select';
import fuzzysearch from 'fuzzysearch';
import AssignmentServices from '../../../services/assignment-services.js';

class ContentStep extends React.Component {

    constructor(props){
        super();
        this.props = props;

        this.props.data.name = this.props.data.name || '';
        console.log(this.props);
        this.state = {
            tabIndex:0,
            limit:10,
            index:0,
            classes:[],
            searchResults:[],
            search:false,
            classStates:{},
            toggleAll:false,
            name:this.props.data.name || '',
        };

        this.props.data.assignedClasses = this.props.data.assignedClasses || [];

        var d =   new Date();
        var due = new Date(); due.setDate(due.getDate() + 14);
        this.date  = {};
        this.props.data.set  = this.date.set =   d.getUnixTime();
        this.props.data.due  = this.date.due =   due.getUnixTime();

        this.handelPageSelect = this.handelPageSelect.bind(this);
        this.handelUserSearch = this.handelUserSearch.bind(this);
    }

    setProps(){

        var keys = Object.keys(this.state.classStates);
        var classes = [];

        for(var idx = 0 ; idx < keys.length; idx++) {
            if (!this.state.classStates[keys[idx]].selected) continue;
            classes.push({
                uid:keys[idx],
                allStudents: this.state.classStates[keys[idx]].students.length == 0 ,
                students:this.state.classStates[keys[idx]].students
            });
        }


        this.props.data.assignedClasses = classes;
    };


    componentDidMount() {
        ClassesService.getViewableClasses();
    }

    processClasses(classes , propsClasses , propsStudents){

        var isClassSelected = function(uid){
            for(var idx = 0 ; idx < propsClasses.length; idx++) if(propsClasses[idx].uid == uid) return true;
            return false
        };

        var getSelectedStudents = function(classStudents){

            var selected = [];

            for(var idx = 0 ; idx < propsStudents.length; idx++)
            {
                for(var jdx = 0 ; jdx < classStudents.length; jdx++)
                {
                    if(propsStudents[idx].uid == classStudents[jdx].uid) selected.push({ value: propsStudents[idx].uid, label: propsStudents[idx].name })
                }
            }

            return selected;
        };

        var classes = ClassesStore.classes;
        var classStates = {};

        for(var idx = 0 ; idx < classes.length; idx++)
        {
            var selected = isClassSelected(classes[idx].getID());
            var students = selected ? [] : getSelectedStudents(classes[idx].students);
            classStates[classes[idx].getID()] = {allStudents:true , selected:selected ? true : students.length > 0 ? true : false , students:students};
        }

        return {classes:classes , classStates:classStates}
    }

    componentWillMount(){
        ClassesStore.on("CHANGE" , () => {
            this.setState(this.processClasses(ClassesStore.classes , this.props.data.classes || [] , this.props.data.students || []));
            this.setProps();
        });
    }

    componentWillReceiveProps(props){
        this.setState(this.processClasses(ClassesStore.classes , props.data.classes || [] , props.data.students || []));
        this.setProps();
    }

    handelSelect(classID){
        var states = this.state.classStates;
            states[classID].selected = !states[classID].selected;
        this.setState({classStates:states});
        this.setProps();

        console.log(this.props.data);
    }

    handelSelectStudents(classID , value ){

        var states = this.state.classStates;
        states[classID].students = value;
        states[classID].selected = value.length > 0 ;
        this.setState({classStates:states});
        this.setProps();
    }

    renderStudentsSelect(classID , students){
        const options = (students || []).map(function(student){

            return  { value: student.uid, label: student.name}
        });

        return <Select placeholder={<FormattedMessage id={ 'ui-897' } defaultMessage={ 'All Students' }/>} value={this.state.classStates[classID].students} 
                multi={true} onChange={this.handelSelectStudents.bind(this , classID)}  options={options}
                noResultsText={<FormattedMessage id={ "ui-2011"} defaultMessage={ "No Results Found" }/>} />

    }

    renderList(){


        return this.getPage(this.state.search ? this.state.searchResults : this.state.classes).map(function(_class){

            return <tr>
                <td>
                    {_class.getName()}
                </td>
                <td>
                    {this.renderStudentsSelect(_class.getID() , _class.students)}
                </td>
                <td width={20}>
                    <Checkbox onChange={this.handelSelect.bind(this , _class.getID())} inline checked={this.state.classStates[_class.getID()].selected}/>
                </td>
             </tr>

        }.bind(this));

    }


    handelKeyDown(){
        clearTimeout(this.state.typingTimer);
    }

    handelKeyUp(){
        clearTimeout(this.state.typingTimer);

        this.setState({
            typingTimer:setTimeout(function(){ this.handelUserSearch(this.search.value) }.bind(this), 500)
        });
    }

    handelPageSelect(index){
        this.setState({index:index - 1});
    }

    handelUserSearch(searchTerm){
        if(searchTerm.length <= 0)
            return this.setState({search:false, searchResults:[], index:0});

        var searchObjects = this.state.classes;

        var results = [];

        for(var idx = 0; idx < searchObjects.length; idx++)
        {
            var searchString = searchObjects[idx].getName()+'|';

            if(fuzzysearch(searchTerm , searchString)){
                results.push(searchObjects[idx]);
            }

        }

        this.setState({
            search:true,
            searchResults:results,
            index:0
        })
    }

    getPage(objects){

        var rowLimit  = parseInt(this.state.limit);
        return objects.slice(this.state.index*rowLimit, (this.state.index*rowLimit) + rowLimit);
    }

    handelSetDataSelect(val){
        this.props.data.set = this.date.set = (new Date(val)).getUnixTime();
        this.setState({update:!this.state.update});
    }

    handelDueDataSelect(val){
        this.props.data.due = this.date.due = (new Date(val)).getUnixTime();
        this.setState({update:!this.state.update});
    }


    handelClassNameChange(e){
        if(e.target.value.length >= 100)
        {
            return
        }

        this.props.data.name = e.target.value;
        this.setState({name:e.target.value});
    }

    render(){



        return <div>
                    <Row>
                        <Col sm={12}>
                            <FormGroup className="fg-line fg-toggled">
                                <ControlLabel  className="fg-label"><FormattedMessage id={ 'ui-2008' } defaultMessage={ 'Assignment Name' }/><small></small></ControlLabel>
                                <FormControl autoFocus value={this.state.name} type="text" onChange={this.handelClassNameChange.bind(this)}/>
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={6}><DataInput onSelect={this.handelSetDataSelect.bind(this)} value={this.date.set} labelTranslationUID="ui-483" labelName="Set"/></Col>
                        <Col sm={6}><DataInput onSelect={this.handelDueDataSelect.bind(this)} value={this.date.due} labelTranslationUID="ui-484" labelName="Due"/></Col>
                    </Row>
                    <Row>
                        <Col sm={12}>
                            <Table striped responsive bordered>
                                <thead>
                                    <tr>
                                        <th><FormattedMessage id={ 'ui-452' } defaultMessage={ 'Class Name' }/></th>
                                        <th colSpan={2}><FormattedMessage id={ 'ui-498' } defaultMessage={ 'Assign to' }/></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.renderList()}
                                </tbody>
                            </Table>
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={12}>
                            <Pagination
                                prev
                                next
                                first
                                last
                                items={this.state.search ? Math.ceil(this.state.searchResults.length/this.state.limit) : Math.ceil(this.state.classes.length/this.state.limit)}
                                maxButtons={5}
                                activePage={this.state.index+1}
                                onSelect={this.handelPageSelect} />
                        </Col>
                    </Row>
                </div>
    }
}

export default {
    name: <FormattedMessage id={ 'ui-000' } defaultMessage={ 'Set & Assign' }/>,
    title:null,
    onSubmit: function (done){

        let AssignClasses = this.props.data.assignedClasses;
        if(this.props.data.name.length == 0)
        {
            return done(new Error(InternationalizationStore.getTranslation("ui-894")));
        }

        return AssignmentServices.setName(this.props.data.homeworkID , this.props.data.name).then(function(){

            var todaysDate = new Date();
            todaysDate.setHours(0,0,0,0)

            console.log(this.props.data)
            if(this.props.data.set <  todaysDate.getUnixTime())
            {
                return done(new Error(InternationalizationStore.getTranslation("ui-673")));
            }

            if((new Date(this.props.data.due)) <  (new Date(this.props.data.set)))
            {
                return done(new Error(InternationalizationStore.getTranslation("ui-673")));
            }

            AssignmentServices.setDates(this.props.data.homeworkID , this.props.data.set , this.props.data.due).then(function(){
                console.log(this.props.data.assignedClasses)
                if(AssignClasses.length == 0)
                {
                    done(new Error(InternationalizationStore.getTranslation("ui-898" ,'You must select at least one class' )));
                }
                else
                {
                    AssignmentServices.setAssigned(this.props.data.homeworkID , AssignClasses).then(function(){
                        done();
                    })
                }
            }.bind(this));
        }.bind(this))

    },
    component: ContentStep
}


// WEBPACK FOOTER //
// ./src/components/wizard/homework-steps/assign-assignments.js